import { getElse } from "../utils/Safe";

/**
 * Model that defines the structure of an asset pack.
 */
export default class AssetPack
{
    constructor()
    {
        /** 
         * Image asset group.
         * @type {*[]}
         */
        this.images = null;
        /** 
         * Json asset group.
         * @type {*[]}
         */
        this.json = null;
        /**
         * Flump asset group.
         * @type {*[]}
         */
        this.flump = null;
        /**
         * Audio asset group.
         * @type {*[]}
         */
        this.audio = null;
        //TODO - Add additional asset groups to support more assets types Phaser can load.
    }

    dispose()
    {
        this.images = null;
        this.json = null;
        this.flump = null;
        this.audio = null;
    }
}

/**
 * Constructs an AssetPack from the information in the data.
 * @param {*} assetPackData 
 */
export function getAssetPack(assetPackData)
{
    let assetPack = new AssetPack();
    
    // Get each of the asset lists from the data. If a list doesn't
    // then fallback to an empty array.
    assetPack.images = getElse([assetPackData, "images"], []);
    assetPack.json = getElse([assetPackData, "json"], []);
    assetPack.flump = getElse([assetPackData, "flump"], []);
    assetPack.audio = getElse([assetPackData, "audio"], []);
    //TODO - Add additional asset groups to support more assets types Phaser can load.

    return assetPack;
}